import { render, staticRenderFns } from "./Makeup.vue?vue&type=template&id=4ea64dfe&scoped=true"
import script from "./Makeup.vue?vue&type=script&lang=js"
export * from "./Makeup.vue?vue&type=script&lang=js"
import style0 from "./Makeup.vue?vue&type=style&index=0&id=4ea64dfe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea64dfe",
  null
  
)

export default component.exports